<div fxLayout="column" fxLayoutAlign="space-between center" style="position: relative; width: 100%; max-height: 100%; height: 100%;">

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-3" style="position: relative; width: 100%; height: 8%;">
        <h1 class="m-0 p-0" style="letter-spacing: .8px;">{{ data.title | translate }}</h1>
        <h2 class="m-0 p-0">{{ displaingImage + 1 }} / {{data.imageSourceAndDescription.length}}</h2>
        <div fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="14px">
            <div class="info-button trans p-1" fxLayoutAlign="center center">
                <mat-icon [svgIcon]="'info'" (click)="handleInfo()"></mat-icon>
            </div>
            <div class="rotate-button trans p-1" fxLayoutAlign="center center">
                <mat-icon [svgIcon]="'material_refresh'" (click)="handleRotate()"></mat-icon>
            </div>
            <div class="close-button trans p-1" fxLayoutAlign="center center">
                <mat-icon [svgIcon]="'close'" (click)="handleClose()"></mat-icon>
            </div>
        </div>
        <div class="image-desctiption py-2 px-3 mt-1" style="position: absolute; top: 100%;" *ngIf="showInfo">
            <ng-container *ngIf="data.translateDescription">
                <p *ngFor="let info of (data.imageSourceAndDescription[displaingImage]?.description ?? {}) | keyvalue">
                    {{info.key | translate}}: {{info.value | translate}}
                </p>
            </ng-container>
            <ng-container *ngIf="!data.translateDescription">
                <p *ngFor="let info of (data.imageSourceAndDescription[displaingImage]?.description ?? {}) | keyvalue">
                    {{info.key}}: {{info.value}}
                </p>
            </ng-container>
        </div>
    </div>

    <mat-dialog-content fxLayout="row" fxLayoutAlign="center center" style="height: 90%; width: 100%; overflow: hidden;">
        <img id="imageViewContentImage" style="height: 100%; width: auto; object-fit: contain; z-index: 1;" *ngIf="!errorDownload">
        <mat-icon [svgIcon]="'invalid_image'" style="width: 100%; height: 20vh;" *ngIf="errorDownload"></mat-icon>
    </mat-dialog-content>


    <div fxLayoutAlign="center center" class="switch-button trans p-1" style="position: absolute; top: 40%; left: 0"
        (click)="handleDisplayPrevious()">
        <mat-icon [svgIcon]="'icon_arrow_left'" style="width: 100%; height: 5vh;"></mat-icon>
    </div>


    <div fxLayoutAlign="center center" class="switch-button trans p-1" style="position: absolute; top: 40%; right: 0"
        (click)="handleDisplayNext()">
        <mat-icon [svgIcon]="'icon_arrow_right'" style="width: 100%; height: 5vh;"></mat-icon>
    </div>

</div>